/* Design-Tokens. Die Werte stehen ebenfalls in tokens.ts; ein Test hält beide deckungsgleich.
   Farbschema: "System" folgt der Geräteeinstellung, "Hell"/"Dunkel" übersteuern sie über
   das Attribut data-ki-scheme am <html>-Element. */

:root {
  --ki-bg: #f3f3f1;
  --ki-surface: #ffffff;
  --ki-surface-raised: #f7f8f9;
  --ki-border: #e3e5e8;
  --ki-text: #1b1b19;
  --ki-muted: #5c626b;
  --ki-accent: #1d4ed8;
  --ki-accent-text: #ffffff;
  --ki-status-ok: #15783d;          --ki-status-ok-bg: #e7f5ec;
  --ki-status-running: #1d4ed8;     --ki-status-running-bg: #e8effb;
  --ki-status-warn: #8a4308;        --ki-status-warn-bg: #fbf0dc;
  --ki-status-bad: #b91c1c;         --ki-status-bad-bg: #fbe9e9;
  --ki-status-off: #54595f;         --ki-status-off-bg: #f0f1f3;

  /* Grundschrift staffelt sich nach Größenklasse; Dichte verschiebt nur die Abstände. */
  --ki-font-size: 14px;
  --ki-row-gap: 6px;
  --ki-tap-min: 28px;

  --ki-font-ui: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
                "Helvetica Neue", Arial, sans-serif;

  color-scheme: light dark;
}

@media (prefers-color-scheme: dark) {
  :root:not([data-ki-scheme="light"]) {
    --ki-bg: #141618;
    --ki-surface: #1d2023;
    --ki-surface-raised: #25282c;
    --ki-border: #33373c;
    --ki-text: #e9ebed;
    --ki-muted: #a3aab2;
    --ki-accent: #8ab0ff;
    --ki-accent-text: #0f1113;
    --ki-status-ok: #5dd78b;        --ki-status-ok-bg: #183424;
    --ki-status-running: #8ab0ff;   --ki-status-running-bg: #1a2740;
    --ki-status-warn: #f2b84b;      --ki-status-warn-bg: #3a2e12;
    --ki-status-bad: #f98a8a;       --ki-status-bad-bg: #3b1e1e;
    --ki-status-off: #a3aab2;       --ki-status-off-bg: #2a2d31;
  }
}

:root[data-ki-scheme="dark"] {
  --ki-bg: #141618;
  --ki-surface: #1d2023;
  --ki-surface-raised: #25282c;
  --ki-border: #33373c;
  --ki-text: #e9ebed;
  --ki-muted: #a3aab2;
  --ki-accent: #8ab0ff;
  --ki-accent-text: #0f1113;
  --ki-status-ok: #5dd78b;          --ki-status-ok-bg: #183424;
  --ki-status-running: #8ab0ff;     --ki-status-running-bg: #1a2740;
  --ki-status-warn: #f2b84b;        --ki-status-warn-bg: #3a2e12;
  --ki-status-bad: #f98a8a;         --ki-status-bad-bg: #3b1e1e;
  --ki-status-off: #a3aab2;         --ki-status-off-bg: #2a2d31;
}

/* Größenklassen. Die Grundschrift folgt der Vorgabe aus dem Entwurf. */
@media (max-width: 743px)  { :root { --ki-font-size: 17px; --ki-tap-min: 44px; --ki-row-gap: 10px; } }
@media (min-width: 744px) and (max-width: 1279px) { :root { --ki-font-size: 15px; --ki-tap-min: 44px; --ki-row-gap: 8px; } }
@media (min-width: 1280px) { :root { --ki-font-size: 14px; --ki-tap-min: 28px; --ki-row-gap: 6px; } }

/* Zweite Achse: das Zeigergerät, nicht die Fensterbreite. Der Entwurf nennt 44 pt als
   Eigenschaft von TOUCH-Geräten — ein iPad Pro im Querformat misst aber 1366 px und fiele
   damit in die Desktop-Staffel: 28-px-Ziele und 14-px-Schrift auf einem reinen
   Touch-Gerät. "pointer: coarse" beschreibt genau das (Finger statt Maus) und steht
   bewusst NACH den Breitenregeln, damit es bei gleicher Spezifität gewinnt. Ein
   Desktop-Fenster mit Maus bleibt unberührt. */
@media (pointer: coarse) {
  :root { --ki-font-size: 15px; --ki-tap-min: 44px; --ki-row-gap: 8px; }
}

:root[data-ki-density="comfortable"] { --ki-row-gap: 12px; }

body {
  margin: 0;
  background: var(--ki-bg);
  color: var(--ki-text);
  font-family: var(--ki-font-ui);
  font-size: var(--ki-font-size);
  line-height: 1.45;
  -webkit-font-smoothing: antialiased;
}

/* Beträge und Nummern immer mit gleich breiten Ziffern. */
.ki-num { font-variant-numeric: tabular-nums; text-align: right; }
